import { adminStore } from '../ui/stores/admin-store'
import { sysNotify } from '../app-states'
import { playEffect } from '../engine/audio'
import { validatePreforgedOffer } from '../commerce/commerce-contract'
import { slugify } from '../ui/helpers/admin-preforge-utils'

export const manageRealitiesService = {
  async saveOffer(offer: any): Promise<void> {
    const errors = validatePreforgedOffer(offer)
    if (errors.length) {
      const message = `Preforged offer invalid: ${errors.join('; ')}`
      sysNotify(message)
      throw new Error(message)
    }
    try {
      await adminStore.savePreforgedOffer(offer)
      sysNotify(`Realized ${offer.kind} ${offer.id}.`)
    } catch (error) {
      const message = `Could not realize preforged offer: ${String(error).slice(0, 160)}`
      sysNotify(message)
      throw error
    }
  },

  async deleteOffer(offerId: string): Promise<void> {
    if (!confirm(`Delete reality ${offerId}? This action is permanent.`)) return
    try {
      await adminStore.deletePreforgedOffer(offerId)
      sysNotify(`Deleted ${offerId}`)
    } catch (error) {
      sysNotify(`Could not delete: ${String(error).slice(0, 140)}`)
    }
  },

  async cloneVersion(offer: any): Promise<string> {
    const currentId = String(offer.id || '')
    const baseId = currentId.replace(/-v\d+$/, '')
    const version = parseInt(currentId.match(/-v(\d+)$/)?.[1] || '1', 10)
    const newId = `${baseId}-v${version + 1}`
    
    const newOffer = {
      ...offer,
      id: newId,
      title: `${offer.title || 'Reality'} (v${version + 1})`,
      publishState: 'draft'
    }
    
    await adminStore.savePreforgedOffer(newOffer)
    sysNotify(`Cloned to new version: ${newId}`)
    return newId
  }
}
